
import { mobileSupabase as supabase } from '@/integrations/supabase/mobile-client';
import { logger } from '@/utils/logger';

// Check if a user is the owner of a family using our security definer function
export const isFamilyOwner = async (familyId: string): Promise<boolean> => {
  try {
    // Use the security definer function we created
    const { data, error } = await supabase
      .rpc('is_family_owner', { family_id: familyId });
    
    if (error) {
      logger.error('Error checking family ownership:', error);
      return false;
    }
    
    return data || false;
  } catch (error) {
    logger.error('Error in isFamilyOwner:', error);
    return false;
  }
};

// Check if a user is a member of a family using our security definer function
export const isFamilyMember = async (familyId: string): Promise<boolean> => {
  try {
    // Use the security definer function we created
    const { data, error } = await supabase
      .rpc('is_family_member', { family_id: familyId });
    
    if (error) {
      logger.error('Error checking family membership:', error);
      return false;
    }
    
    return data || false;
  } catch (error) {
    logger.error('Error in isFamilyMember:', error);
    return false;
  }
};
